import { events } from '@/services/analytics';
import { analytics } from '@/utils/analytics-factory';

export interface AgeRestrictionPayload {
	terminal_id: number;
	product_id: number;
	product_name: string;
}

type AgeRestrictionAction = 'accepted' | 'declined' | 'closed';

export const useAgeRestrictionAnalytics = () => {
	const trackOnOpened = (payload: AgeRestrictionPayload) => {
		analytics.logEvent(events.AGE_RESTRICTION_SHOWN, payload);
	};

	const trackAction = (
		action: AgeRestrictionAction,
		payload: AgeRestrictionPayload
	) => {
		analytics.logEvent(events.AGE_RESTRICTION_ACTION, {
			...payload,
			action
		});
	};

	const trackConfirmation = trackAction.bind(null, 'accepted');
	const trackCancellation = trackAction.bind(null, 'declined');
	const trackOnClosed = trackAction.bind(null, 'closed');

	return {
		trackOnOpened,
		trackConfirmation,
		trackCancellation,
		trackOnClosed
	};
};
